module.exports = __webpack_public_path__ + "static/media/coffee-pot.3a55f877.svg";